import React from "react";
import styles from "./Modal.module.scss";

type ModalProps = {
  children: React.ReactNode;
  onClose?: () => void;
  onOverlayClick?: () => void;
};

const Modal = ({children, onClose, onOverlayClick}: ModalProps) => {
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget) {
      return;
    }
    if (onOverlayClick) {
      onOverlayClick();
      return;
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className={styles.modal}>
      <div
        className={styles.overlay}
        onClick={handleOverlayClick}
        role="presentation"
        aria-hidden={true}
      />
      <div className={styles.container}>{children}</div>
    </div>
  );
};

export default Modal;
